<div class="flex flex-row justify-end items-center">
  <button mat-icon-button class="close-button" mat-dialog-close>
    <mat-icon class="close-icon" color="accent">close</mat-icon>
  </button>
</div>
<div class="sm:px-6 px-1 bg-white ">
  <h2 *ngIf="data.isEdit === false" class="font-bold text-xl" mat-dialog-title>
    {{ "insertRecoveryPlanTitle" | translate | async }}
  </h2>
  <h2 *ngIf="data.isEdit === true" class="font-bold text-xl" mat-dialog-title>
    {{ "editRecoveryPlanTitle" | translate | async }}
  </h2>
  <div class="overflow-hidden h-full ">
    <app-dynamic-form
      *ngIf="formGroupStart"
      [formGroup]="formGroupStart"
      [inputForm]="inputFormStart"
      [appearanceForm]="'outline'"
    >
    </app-dynamic-form>

    <div class="w-full p-2" *ngIf="data.isEdit">
      <div  class="w-full p-2 border-[2px] border-solid rounded-lg mb-2">
        <div class="flex flex-row justify-between cursor-pointer py-2"  [ngClass]="{'pb-4 border-solid border-b-[1px]': openInfo}" (click)="openInfo =!openInfo">
          <div class="flex flex-row justify-start items-center  pl-2 text-black" >{{utils.traslatei18n('Comments/Actions')}}</div>
        
            <mat-icon *ngIf="!openInfo">keyboard_arrow_down</mat-icon>

          
            <mat-icon *ngIf="openInfo">expand_less</mat-icon>
 
        </div>
        <div  *ngIf="openInfo" class="h-[200px] overflow-auto">
            <div *ngFor="let item of data.additionalInformation" class="border-solid border-b-[1px]">
                <div class="w-full p-2 flex flex-row justify-start items-start font-bold">
                  <div class="text-md">
                    {{ item.type === 0 ?  utils.traslatei18n('Comment') : utils.traslatei18n('Action') }}
                  </div>
      
                </div>
                <div class="w-full p-2 text-black/60">
                  {{ item.additionalInfo }}
                </div>
                <div class="w-full p-2 flex flex-row justify-end items-start font-bold">

                  <div class="flex flex-col justify-center items-end ">
                    <div class="text-xs text-black/60">
                      {{item.usrInsert ? item.usrInsert : ''}}
                    </div>
                    <div class="text-xs text-black/50">
                      {{parseDate(item.dtInsert)}}
                    </div>
                  </div>
                </div>
              </div>
        </div>
       
      </div>
    </div>

    <div class="flex flex-row w-full items-center" *ngFor="let item of groupInfo; let i = index">
      <div class="w-full" *ngIf="item">
        <app-dynamic-form
          *ngIf="item"
          [formGroup]="item"
          [inputForm]="inputFormAdditionalInformation"
          [appearanceForm]="'outline'"
        >
        </app-dynamic-form>
      </div>

      <div class="p-2" *ngIf="item">
        <button
          *ngIf="i + 1 === groupInfo.length"
          mat-icon-button
          (click)="addInfo()"
          color="accent"
        >
          <mat-icon class="">add</mat-icon>
        </button>
        <button
          *ngIf="i + 1 !== groupInfo.length"
          mat-icon-button
          (click)="removeInfo(i)"
          color="warn"
        >
          <mat-icon>remove</mat-icon>
        </button>
      </div>
    </div>



    <app-dynamic-form
      *ngIf="formGroupEnd"
      [formGroup]="formGroupEnd"
      [inputForm]="inputFormEnd"
      [appearanceForm]="'outline'"
    >
    </app-dynamic-form>
    <div class="p-2" *ngIf="data.isEdit && data.attach">
      <div class="flex flex-row justify-center items-center w-full rounded-lg hover:text-white hover:bg-[#223e80]  py-2 cursor-pointer" matRipple  (click)="downloadFile()">
        <div class="px-1">Download File</div>
        <mat-icon class="px-1">file_download</mat-icon>
      </div>
    </div>
  

    <div class="flex w-full items-center justify-center bg-grey-lighter p-2 mb-4 group">
      <label *ngIf="!file"
          class="w-full flex flex-col items-center px-6 py-6 bg-white text-blue rounded-lg border-2 border-[#223e80] border-dashed tracking-wide uppercase   cursor-pointer hover:bg-[#223e80] hover:text-white">

          <img src='../../../../assets/svg/up.svg' class="w-8 h-8 text-[#223e80] " />
          <span class="mt-2 text-base leading-normal ">{{utils.traslatei18n('Select a file')}}</span>
          <input type='file' (change)="incomingfile($event)" class="hidden" accept=".pdf, .doc, .xlsx, .txt" />

      </label>
      <div *ngIf="file"
          class="w-full flex flex-col items-center px-6 py-6 bg-white text-blue rounded-lg border-2 border-[#223e80] border-dashed tracking-wide uppercase   cursor-pointer  ">
          <img src='../../../../assets/svg/load.svg' class="w-8 h-8 text-[#223e80] " />
          <button mat-button>
              <div class="flex flex-row justify-between items-center" (click)="deleteFile()">
                  <div class="mt-2 text-base leading-normal ">{{file.name}}</div>
                  <mat-icon class="mx-2">delete</mat-icon>
              </div>

          </button>
          <div *ngIf="sizeError" class="text-red-500">{{utils.traslatei18n('uploaded file is too large')}}</div>
      </div>
  </div>
  </div>
  <mat-dialog-actions class="justify-between">
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <div class="w-full">
      <div class="flex flex-col justify-center items-center m-auto">
        <button
          mat-raised-button
          color="accent"
          [disabled]="isDisable()"
          [mat-dialog-close]="returnValue()"
          class="w-1/3"
        >
          {{ this.utils.traslatei18n("Save") }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>
